export const SAVED_COURSES_KEY = 'SAVED_COURSES';
export const SAVED_COURSES_SELECTOR = 'saved-courses-tab';
